export default __webpack_public_path__ + "static/media/HeaderFlower.12f1ecb6.png";